import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MainStore } from 'src/app/common/main.store';
import { DbTemplateService } from '../db-template.service';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-db-template-create',
    templateUrl: './db-template-create.component.html',
    styleUrl: './db-template-create.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class DbTemplateCreateComponent {

  
  // Db templates
  dbNameInput: string = '';
  dbSchemaInput: string = 'dbo';
  dbTypeInput: string = 'Table';

  dbTypes: string[] = ['Table', 'View', 'Stored Procedure'];
  // templateNameInput: string = '';
  isCreatingTemplate: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private store: MainStore,
    private templateService: DbTemplateService,
    private toastrService: ToastrService,
    private router: Router

  ) {
    // if (this.is200AdminUser == true && 
    //     ! this.store.GetCurrentUser().isAdmin && this.store.GetCurrentUser().departmentCode == '200')
    // {
    //   this.is200AdminUser = false;
    // }
  }

  disabled(): boolean {
    if (this.dbNameInput.length > 0 && ! this.isCreatingTemplate && this.dbSchemaInput.length > 0)
    {
      return false;
    }
    return true;
  }
  createTemplate(): void {
    this.isCreatingTemplate = true;
    this.templateService.createDbTemplate(this.dbNameInput, this.dbSchemaInput, this.dbTypeInput).then((newid: string) => {
      this.toastrService.success("Databasetemplate oprettet");
      this.router.navigate(['/db-template/'+ newid]);      
      this.activeModal.close("close click");
    }).catch(() => {
      // HTTP-fejl vises globalt af GlobalErrorInterceptor/ErrorService
    }).finally(() => {
      this.isCreatingTemplate = false;
    });
  }
}
